module.exports = __webpack_public_path__ + "img/owner-placeholder.9bde4065.jpeg";